/* PabDer — Quick Add drawer (colour + size picker) + card image carousel companion */
(function () {
  var drawer, scrim, body, closeBtn;
  var state = { product: null, sel: [], currentVariant: null };

  function $(id) { return document.getElementById(id); }

  function money(cents) {
    if (window.PDCurrency && window.PDCurrency.isForeign()) {
      return window.PDCurrency.formatUsd(cents / 100);
    }
    var amount = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      var fmt = window.Shopify.moneyFormat || '₱{{amount}}';
      return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100));
    }
    return '₱' + amount;
  }

  function open() {
    drawer.classList.add('open');
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
  }

  function close() {
    drawer.classList.remove('open');
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  function optionName(product, idx) {
    var opt = product.options[idx];
    if (opt == null) return '';
    return typeof opt === 'string' ? opt : (opt.name || '');
  }

  function findOptionIndex(product, matchNames) {
    for (var i = 0; i < product.options.length; i++) {
      var n = optionName(product, i).toLowerCase();
      for (var j = 0; j < matchNames.length; j++) {
        if (n.indexOf(matchNames[j]) > -1) return i;
      }
    }
    return -1;
  }

  function optVal(variant, idx) {
    return [variant.option1, variant.option2, variant.option3][idx];
  }

  function updateCurrentVariant() {
    var p = state.product;
    var allSet = state.sel.every(function (v) { return v != null; });
    if (!allSet) { state.currentVariant = null; return; }
    state.currentVariant = p.variants.find(function (v) {
      for (var i = 0; i < state.sel.length; i++) {
        if (optVal(v, i) !== state.sel[i]) return false;
      }
      return true;
    }) || null;
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function findDisplayVariant() {
    var p = state.product;
    if (state.currentVariant) return state.currentVariant;
    // partial match on whatever options are already picked (e.g. colour chosen, size not yet)
    // so the preview image/price reflect that choice immediately
    var match = p.variants.find(function (v) {
      for (var i = 0; i < state.sel.length; i++) {
        if (state.sel[i] != null && optVal(v, i) !== state.sel[i]) return false;
      }
      return true;
    });
    return match || p.variants[0];
  }

  function render() {
    var p = state.product;
    if (!p) return;
    var colorIdx = findOptionIndex(p, ['color', 'colour', '顔色', '顏色', '色']);
    var sizeIdx = findOptionIndex(p, ['size', '尺寸', '尺碼']);
    var refVariant = findDisplayVariant();
    var img = (refVariant && refVariant.featured_image && refVariant.featured_image.src) || p.featured_image || (p.images && p.images[0]);

    var html = '';
    html += '<div class="qa-summary">';
    html += '<div class="qa-summary__img">' + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="' + esc(p.title) + '">' : '') + '</div>';
    html += '<div class="qa-summary__info"><div class="qa-summary__name">' + esc(p.title) + '</div><div class="qa-summary__price">' + money(refVariant.price) + '</div></div>';
    html += '</div>';

    if (colorIdx > -1) {
      var seenC = {}, colorOpts = [];
      p.variants.forEach(function (v) {
        var val = optVal(v, colorIdx);
        if (val && !seenC[val]) { seenC[val] = true; colorOpts.push(val); }
      });
      if (colorOpts.length > 1) {
        html += '<div class="qa-label">Colour<span class="qa-label__val">' + (state.sel[colorIdx] ? ' — ' + esc(state.sel[colorIdx]) : '') + '</span></div><div class="qa-colors">';
        colorOpts.forEach(function (val) {
          var active = state.sel[colorIdx] === val ? ' is-active' : '';
          html += '<button type="button" class="qa-color' + active + '" data-idx="' + colorIdx + '" data-val="' + esc(val) + '" onclick="pdQaSelect(this)">' + esc(val) + '</button>';
        });
        html += '</div>';
      }
    }

    if (sizeIdx > -1) {
      var seenS = {}, sizeOpts = [];
      p.variants.forEach(function (v) {
        var val = optVal(v, sizeIdx);
        if (val && !seenS[val]) { seenS[val] = true; sizeOpts.push(val); }
      });
      if (sizeOpts.length > 1) {
        html += '<div class="qa-label">Size</div><div class="qa-sizes">';
        sizeOpts.forEach(function (val) {
          var testSel = state.sel.slice();
          testSel[sizeIdx] = val;
          var match = p.variants.find(function (v) {
            for (var i = 0; i < testSel.length; i++) {
              if (testSel[i] != null && optVal(v, i) !== testSel[i]) return false;
            }
            return true;
          });
          var avail = match && match.available;
          var active = state.sel[sizeIdx] === val ? ' is-active' : '';
          var cls = 'qa-size' + active + (avail ? '' : ' is-oos');
          html += '<button type="button" class="' + cls + '" data-idx="' + sizeIdx + '" data-val="' + esc(val) + '"' + (avail ? ' onclick="pdQaSelect(this)"' : ' disabled') + '>' + esc(val) + '</button>';
        });
        html += '</div>';
      }
    }

    var btnLabel, btnDisabled;
    if (state.currentVariant && state.currentVariant.available) { btnLabel = 'Add to Bag'; btnDisabled = false; }
    else if (state.currentVariant) { btnLabel = 'Sold Out'; btnDisabled = true; }
    else { btnLabel = 'Select Options'; btnDisabled = true; }

    html += '<button type="button" class="btn btn-primary btn-block btn-lg qa-add" id="qaAddBtn"' + (btnDisabled ? ' disabled' : '') + '>' + btnLabel + '</button>';

    body.innerHTML = html;
  }

  function addToCart() {
    if (!state.currentVariant || !state.currentVariant.available) return;
    var btn = $('qaAddBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: state.currentVariant.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add failed'); }); return r.json(); })
      .then(function () {
        close();
        var trigger = $('cartDrawerTrigger');
        if (trigger) trigger.click();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Bag'; }
        alert('Sorry, something went wrong adding this to your bag. Please try again.');
      });
  }

  window.pdQaSelect = function (btn) {
    var idx = parseInt(btn.getAttribute('data-idx'), 10);
    var val = btn.getAttribute('data-val');
    state.sel[idx] = val;
    updateCurrentVariant();
    render();
  };

  window.pdQuickAdd = function (btn) {
    var card = btn.closest('.pd-prod');
    if (!card) return;
    var handle = card.getAttribute('data-handle');
    if (!handle || btn.classList.contains('is-loading')) return;
    var activeSwatch = card.querySelector('.pd-prod__swatch.is-active');
    var initialColor = activeSwatch ? activeSwatch.getAttribute('data-color') : null;
    btn.classList.add('is-loading');

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.classList.remove('is-loading');
        state.product = p;
        state.sel = p.options.map(function () { return null; });
        var hasChoice = false;
        p.options.forEach(function (name, idx) {
          var vals = {};
          p.variants.forEach(function (v) { var val = optVal(v, idx); if (val) vals[val] = true; });
          var keys = Object.keys(vals);
          if (keys.length === 1) { state.sel[idx] = keys[0]; } else { hasChoice = true; }
        });
        var colorIdx = findOptionIndex(p, ['color', 'colour', '顔色', '顏色', '色']);
        if (colorIdx > -1 && initialColor) state.sel[colorIdx] = initialColor;
        updateCurrentVariant();

        if (!hasChoice && state.currentVariant) {
          addToCart();
        } else {
          render();
          open();
        }
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (window.console) console.error('pdQuickAdd failed:', err);
      });
  };

  function init() {
    drawer = $('qaDrawer');
    scrim = $('qaDrawerScrim');
    body = $('qaBody');
    closeBtn = $('qaDrawerClose');
    if (!drawer || !scrim || !body) return;
    if (closeBtn) closeBtn.addEventListener('click', close);
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    body.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'qaAddBtn') addToCart();
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
